import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "@/css/index.css";
import history from "@/utils/history";
const Layout = React.lazy(() => import("./views/layout/index"));
const Index = React.lazy(() => import("./views/index/index"));
const Betas = React.lazy(() => import("./views/betas/index"));
const Upload = React.lazy(() => import("./views/upload/index"));
const Pricing = React.lazy(() => import("./views/pricing/index"));
const Applist = React.lazy(() => import("./views/applist/index"));
const Register = React.lazy(() => import("./views/register/index"));
const More = React.lazy(() => import("./views/more/index"));
const News = React.lazy(() => import("./views/news/index"));
const User = React.lazy(() => import("./views/user/index"));
const Contact = React.lazy(() => import("./views/contact/index"));
const About = React.lazy(() => import("./views/about/index"));
const Agreement = React.lazy(() => import("./views/agreement/index"));
const UserAgreement = React.lazy(() => import("./views/userAgreement/index"));
const Feedback = React.lazy(() => import("./views/feedback/index"));
const Support = React.lazy(() => import("./views/support/index"));
const Cooperate = React.lazy(() => import("./views/cooperate/index"));
const Down = React.lazy(() => import("./views/down/index"));
const Orders = React.lazy(() => import("./views/orders/index"));
const Partners = React.lazy(() => import("./views/partners/index"));
const Recharge = React.lazy(() => import("./views/recharge/index"));
const Uploadold = React.lazy(() => import("./views/uploadold/index"));
const Verification = React.lazy(() => import("./views/verification/index"));

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Navigate to="/views/index" />} />
            <Route path="/views" element={<Layout />}>
              <Route index element={<Index />} />
              <Route path="index" element={<Index />} />
              <Route path="betas" element={<Betas />} />
              <Route path="upload" element={<Upload />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="applist" element={<Applist />} />
              <Route path="register" element={<Register />} />
              <Route path="more" element={<More />} />
              <Route path="news" element={<News />} />
              <Route path="user" element={<User />} />
              <Route path="contact" element={<Contact />} />
              <Route path="about" element={<About />} />
              <Route path="agreement" element={<Agreement />} />
              <Route path="userAgreement" element={<UserAgreement />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="support" element={<Support />} />
              <Route path="cooperate" element={<Cooperate />} />
              <Route path="down" element={<Down />} />
              <Route path="orders" element={<Orders />} />
              <Route path="partners" element={<Partners />} />
              <Route path="recharge" element={<Recharge />} />
              <Route path="uploadold" element={<Uploadold />} />
              <Route path="verification" element={<Verification />} />
            </Route>
          </Routes>
        </React.Suspense>
      </Router>
    </div>
  );
}

export default App;
